export const SUPPORTED_EXTENSIONS = [
  '.pdf',
  '.txt',
  '.md',
  '.markdown',
  '.xlsx',
  '.xlsm',
  '.xls',
  '.docx',
  '.doc',
  '.pptx',
  '.ppt',
  '.pdf',
  'application/pdf',
  'text/plain',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.ms-powerpoint'
];
export function isFileSupported(fileName: string): boolean {
  const lowerCaseFileName = fileName.toLowerCase();
  return SUPPORTED_EXTENSIONS.some(ext => lowerCaseFileName.endsWith(ext));
}
